<template>
  <div class="dialog-wrap">
    <el-dialog title="新建信息"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="内容类型"
                      prop="question_id">
          <el-select v-model="dataForm.question_id"
                     placeholder="请选择"
                     clearable>
            <el-option v-for="(item, index) in typeList"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div> <el-form-item label="适合院校："
                        prop="colleges">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in colleges"
                      closable
                      :disable-transitions="false"
                      @close="handleCollegeRemove(item)">
                {{ `${item.name}` }}
              </el-tag>
              <el-button type="text"
                         @click="handleCollegeChoose">选择院校</el-button>
            </div>
          </el-form-item></div>

        <el-form-item label="适合专业："
                      prop="majors">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in majors"
                    closable
                    :disable-transitions="false"
                    @close="handleMajorRemove(item)">
              {{ `${item.name}/${item.code}` }}
            </el-tag>
            <el-button type="text"
                       @click="handleMajorChoose">选择专业</el-button>
          </div>
        </el-form-item>
        <el-form-item label="回答内容"
                      prop="answer_content">
          <el-input v-model="dataForm.answer_content"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item label="上传图片"
                      prop="avatar">
          <el-upload :action="imgUploadUrl"
                     accept=".png,.jpg,.jpeg"
                     list-type="picture-card"
                     :on-preview="handlePictureCardPreview"
                     :on-remove="handleRemove"
                     :on-success="handleSuccess"
                     :file-list="fileList">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="发布人："
                      prop="uid ">
          <el-select v-model="dataForm.uid "
                     filterable
                     remote
                     reserve-keyword
                     :remote-method="fetchAuthorList"
                     placeholder="这里是发布人姓名及手机号"
                     style="width: 70%;">
            <el-option :label="`${item.realname}/${item.mobile}`"
                       :value="item.id"
                       v-for="item in authors"
                       :key="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>
    <el-dialog :visible.sync="dialogVisibleDia">
      <img width="100%"
           :src="dialogImageUrl"
           alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { teacherCreate } from '@/api/common'
import { seniorList, userAnswerCreated } from '@/api/senior'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import MajorChoose from '@/components/dialog/major/MajorChoose'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
export default {
  components: { MajorChoose, CollegeChoose },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    typeList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      dialogVisibleDia: false,
      colleges: [],
      majors: [],
      authors: [],
      fileList: [],
      majorChooseDialog: false,
      collegeChooseDialog: false,
      dialogVisible: this.visible,
      dialogImageUrl: '',
      dataForm: {
        answer_img_urls: '',
        status: false,
      },
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      rules: {
        // colleges: [
        //   { required: true, message: '请输入院校', trigger: 'change' },
        // ],
        // majors: [{ required: true, message: '请输入专业', trigger: 'change' }],
        virtual_like_count: [
          { required: true, message: '请输入点赞量', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择发布状态', trigger: 'blur' },
        ],
        uid: [
          {
            required: true,
            message: '请输入发布人姓名及手机号',
            trigger: 'change',
          },
        ],
        answer_content: [
          {
            required: true,
            message: '请输入回答内容',
            trigger: 'blur',
          },
        ],
        question_id: [
          {
            required: true,
            message: '请选择内容分类',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    fetchAuthorList(name) {
      seniorList({ keyword: name, isPaging: 0 }).then((res) => {
        this.authors = res.list
      })
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let picture_url = this.fileList.map((item) => item.url).join(',')
          const params = Object.assign({}, this.dataForm, {
            apply_college_code: this.colleges[0].code,
            apply_college_name: this.colleges[0].name,
            apply_major_code: this.majors[0].code,
            apply_major_name: this.majors[0].name,
            answer_img_urls: picture_url,
          })
          userAnswerCreated(params)
            .then((res) => {
              this.$refs['dataForm'].resetFields()

              this.$emit('submit')
              this.dataForm = {
                question_id: '',
                answer_content: '',
                answer_img_urls: '',
                virtual_like_count: '',
                uid: '',
              }
              this.value = false
              this.colleges = []
              this.majors = []
              this.fileList = []
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },

    // handleUploadSuccess(res, file) {
    //   if (res.code == 0 && res.data) {
    //     this.dataForm.answer_img_urls = res.data.url
    //   } else {
    //     this.$message.error(res.error)
    //   }
    // },
    // handleUploadQrcodeSuccess(res, file) {
    //   if (res.code == 0 && res.data) {
    //     this.dataForm.answer_img_urls = res.data.url
    //   } else {
    //     this.$message.error(res.error)
    //   }
    // },
    // handleBeforeUpload(file) {
    //   const isLt2M = file.size / 1024 / 1024 < 2

    //   if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 2MB!')
    //   }
    //   return isLt2M
    // },
  },
}
</script>

<style lang="less" scoped>
.xing {
  color: red;
}
.upload-button {
  width: 100%;

  /deep/ .el-upload {
    width: 100%;
  }
  /deep/ .el-upload-dragger {
    width: 100%;
    height: 220px;
  }
  .el-upload-tip {
    font-size: 12px;
    color: #606266;
    margin-top: 7px;
  }
  .upload-text {
    margin-bottom: 10px;

    /*      &:before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        } */
  }
}
::v-deep .el-dialog__header {
  background: #ebeef5 !important;
}
.dialog-wrap {
  .form {
    margin-bottom: -18px;

    .avatar-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 128px;
      height: 128px;
      line-height: 128px;
      text-align: center;
    }
    .avatar {
      display: block;
      width: 128px;
      height: 128px;
      object-fit: cover;
    }
  }
}
</style>
